// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.campaignModal .header {
  display: flex;
  align-items: center;
  margin-bottom: 1.875rem;
}
.campaignModal .header h4 {
  margin-bottom: 0;
  margin-left: 1.25rem;
}
.campaignModal .banner {
  height: 600px;
  margin: 1.25rem 0;
  object-fit: contain;
}
.campaignModal .gray-bg {
  background-color: #d3d3d3;
  text-align: center;
  padding: 0.625rem;
}
.campaignModal .right-bar {
  padding: 0;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.campaignModal .right-bar p {
  margin-bottom: 0;
}
.campaignModal .right-bar .top {
  padding: 0 1.25rem 0 1.25rem;
}

.campaignModal .gray-bg .head,
.campaignModal .conversion .head {
  color: black;
  font-size: 1.125rem;
  margin-bottom: 0.625rem;
}
.campaignModal .conversion {
  text-align: center;
  margin: 1.875rem 0;
}
`, "",{"version":3,"sources":["webpack://./src/styles/components/campaignDetail.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,4BAA4B;AAC9B;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB","sourcesContent":[".campaignModal .header {\n  display: flex;\n  align-items: center;\n  margin-bottom: 1.875rem;\n}\n.campaignModal .header h4 {\n  margin-bottom: 0;\n  margin-left: 1.25rem;\n}\n.campaignModal .banner {\n  height: 600px;\n  margin: 1.25rem 0;\n  object-fit: contain;\n}\n.campaignModal .gray-bg {\n  background-color: #d3d3d3;\n  text-align: center;\n  padding: 0.625rem;\n}\n.campaignModal .right-bar {\n  padding: 0;\n  min-height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.campaignModal .right-bar p {\n  margin-bottom: 0;\n}\n.campaignModal .right-bar .top {\n  padding: 0 1.25rem 0 1.25rem;\n}\n\n.campaignModal .gray-bg .head,\n.campaignModal .conversion .head {\n  color: black;\n  font-size: 1.125rem;\n  margin-bottom: 0.625rem;\n}\n.campaignModal .conversion {\n  text-align: center;\n  margin: 1.875rem 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
